/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SaveAffiliateProgram200Response
 */
export interface SaveAffiliateProgram200Response {
  /**
   *
   * @type {boolean}
   * @memberof SaveAffiliateProgram200Response
   */
  status: boolean
  /**
   *
   * @type {string}
   * @memberof SaveAffiliateProgram200Response
   */
  message: string
}

/**
 * Check if a given object implements the SaveAffiliateProgram200Response interface.
 */
export function instanceOfSaveAffiliateProgram200Response(
  value: object
): value is SaveAffiliateProgram200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('message' in value) || value['message'] === undefined) return false
  return true
}

export function SaveAffiliateProgram200ResponseFromJSON(
  json: any
): SaveAffiliateProgram200Response {
  return SaveAffiliateProgram200ResponseFromJSONTyped(json, false)
}

export function SaveAffiliateProgram200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveAffiliateProgram200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    message: json['message'],
  }
}

export function SaveAffiliateProgram200ResponseToJSON(
  value?: SaveAffiliateProgram200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    message: value['message'],
  }
}
